export default __webpack_public_path__ + "static/ruinedKingHeroMobile-7eb580c4f4e546601763e14685a4e0b2.png";